import { Component, ElementRef, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { QuestionDTO, DateUtilsService, AuctionItemState, ConfigurationState } from 'remarketing-angular-library';
import { get as _get } from 'lodash';
import { Store } from '@ngxs/store';
import { DateTimeFormat } from 'remarketing-angular-library/enums/dateTime.enum';
import { NgClass } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'lib-question-block',
    templateUrl: './question-block.component.html',
    styleUrls: ['./question-block.component.scss'],
    imports: [TranslocoDirective, NgClass]
})
export class QuestionBlockComponent implements OnInit {
  @Output() toggleActiveQuestion = new EventEmitter<QuestionDTO>();
  @Input() open = false;
  @Input() questions: QuestionDTO[] = [];
  @Input() identifier?: string;
  @Input() dealerUuid: string;
  @Input() showUserName: boolean;
  @Output() userUuid = new EventEmitter<string>();
  showReplyBtn = true;
  isAdmin = false;

  vehicleStatus: string;

  get withdrawnQuestion() {
    return !!this.questions[0].withdrawnDate;
  }

  get status() {
    return _get(this.questions, '[0].answer') || _get(this.questions, '[0].withdrawnDate') ? 'answered' : 'unanswered';
  }

  get hasHistory() {
    return this.questions.length > 1 && this.questions.some(q => !!q.answer);
  }

  get question() {
    return _get(this.questions, '[0]', undefined);
  }

  get isQuestionActionable() {
    return !this.questions[0].readOnly;
  }

  get askedDate() {
    return this.dateUtilService.localizeDateAndTime(this.questions[0].askedDate, true);
  }

  get answerDate() {
    return this.dateUtilService.localizeDateAndTime(this.questions[0].answeredDate, true);
  }

  get askedBy() {
    return _get(this.questions, '[0].askedBy');
  }

  constructor (
    private readonly store: Store,
    private readonly el: ElementRef,
    private readonly dateUtilService: DateUtilsService
  ) { }

  ngOnInit() {
    this.isAdmin = this.store.selectSnapshot(ConfigurationState.isAdmin());
    this.store.select(AuctionItemState.auctionItem).subscribe(item => {
      if (item) {
        this.vehicleStatus = item.auctionItemStatus;
      }
    });
  }

  focus() {
    const toggle = this.el.nativeElement.querySelector('.toggle-btn');
    if (toggle) {
      toggle.focus();
    }
  }

  toggle(event: Event) {
    if (!this.open) {
      this.userUuid.emit(this.question.askedByUuid);
    }
    this.toggleActiveQuestion.emit(this.questions[0]);

    if (event.target) {
      const target = (event.target as HTMLElement).closest('.question-container__user-block');
      setTimeout(() => {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 0);
    }

    // focus on heading when opening
    if (this.open) {
      setTimeout(() => {
        const heading = document.querySelector('h2') as HTMLElement;
        if (heading) {
          heading.focus();
        }
      }, 200);
    }
  }
}
